<template>
    <div  :style="cssPropsInput" class="field-container" :class="class_width">
        <label for="booking_cms_input_guests" :style="getStylesLabel">{{ config.label }}</label>
        <input id="booking_cms_input_guests" @click.stop="toggleOpenPopup" :readonly="true" v-model="guestsValue" :style="getStylesInput" type="text">
        <div class="field-container__guest-popup">
            <div v-if="isOpenPopup">
                <div class="section-popup">
                    <label for="booking_cms_input_guest_adults">{{ config.labelAdultGuests }}</label>
                    <div class="input">
                        <input id="booking_cms_input_guest_adults" :readonly="true"  v-model="adultsValue" type="text">
                        <button @click.prevent="changeValueAdults('subtract')">
                            -
                        </button>
                        <button @click.prevent="changeValueAdults('add')">
                            +
                        </button>
                    </div>
                </div>
                <div class="section-popup">
                    <label for="booking_cms_input_guest_children">{{ fields['children']['label'] }}</label>
                    <div class="input">
                        <input id="booking_cms_input_guest_children" :readonly="true" v-model="childrenValue" type="text">
                        <button @click.prevent="changeValueChildren('subtract')">
                            -
                        </button>
                        <button @click.prevent="changeValueChildren('add')">
                            +
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default{
        name: 'BookingGuest',
        props:{
            attributes: Object,
            config: Object,
            icon: String,
            booking_data: Object,
            class_width: String,
            backgroundColor: String,
            fields: Object
        },
        computed: {
          
            getStylesLabel(){
                const  { border , backgroundColor , fontSize , fontSizeLabel , fontSizeLabelInside , padding , ...rest  } = this.attributes
                const paddings = padding.split(' ')
                if( this.attributes['label-inside'] ){
                    return {
                        position: 'absolute',
                        transition: 'all 0.2s ease',
                        fontSize: fontSizeLabel,
                        top: paddings[0],
                        left: paddings[3],
                        pointerEvents: 'none',
                        ...rest
                    }
                }else{
                    return { 
                        ...rest,
                        fontSize: fontSizeLabel
                    }
                }
               
            },
            getSelectLabel(){
                return this.config.labelSelect
            },
            getStylesInput(){
                const {  border , lineHeight , fontSizeLabel , fontSizeLabelInside  , ...rest } = this.attributes
                return{
                    ...rest,
                    backgroundImage: `url(${this.icon})`,
                    backgroundSize: 'auto 8px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPositionY: 'center',
                    backgroundPositionX: 'calc(100% - 15px)',
                    borderTop: border.top,
                    borderBottom: border.bottom,
                    borderRight: border.right,
                    borderLeft: border.left,
                }
            },
            cssPropsInput(){
                return {
                    '--color-placeholder' :  this.attributes.color,
                    '--text-transform-placeholder': this.attributes.textTransform,
                    '--background-color': this.backgroundColor
                }
            }
           
        },
        data(){
            return{
                guestsValue: null,
                childrenValue: this.getRange().minRangeChildren,
                adultsValue: this.getRange().minRangeAdults,
                isOpenPopup: false,
                mutableBookingData: this.booking_data
            }
        },
        mounted(){  
            this.guestsValue =  this.attributes['label-inside'] ? null :`${String(this.getRange().minRangeChildren + this.getRange().minRangeAdults)} ${this.getSelectLabel}`;

            const heightContainerBooking = document.querySelector('.booking-cms__content').offsetHeight
            const heightCMSForm = document.querySelector('.booking-cms__form').offsetHeight
            const containerGuestPopup = document.querySelector('.field-container__guest-popup');
            const calculatePosition = (heightContainerBooking - heightCMSForm)/2

            const bookingFixedContainer =  document.getElementById('bookingFixedContainer');
            if(bookingFixedContainer){
                if(bookingFixedContainer.classList.contains('top')){
                    containerGuestPopup.style.top = `calc(100%  + ${ String(calculatePosition) }px)`;
                }else{
                    containerGuestPopup.style.bottom = `calc(100%  + ${ String(calculatePosition) }px)`;
                }
            }else{
                containerGuestPopup.style.top = `100%`;
            }
            // containerGuestPopup.style.top = `calc(100%  + ${ String(calculatePosition) }px)`;
            document.querySelector('body').addEventListener('click' , ()=>{
                this.isOpenPopup = false
            })
            containerGuestPopup.addEventListener('click' , (e)=>{
                e.stopPropagation()
            })
        },
        watch:{
            childrenValue: function(){
                this.$parent.$parent.$emit('update-data',{
                    children: this.childrenValue
                })
                this.guestsValue = `${String(this.childrenValue + this.adultsValue)} ${this.getSelectLabel}`
            },
            adultsValue: function(){
                this.guestsValue = `${String(this.childrenValue + this.adultsValue)} ${this.getSelectLabel}` 
                this.$parent.$parent.$emit('update-data',{
                    adults: this.adultsValue
                })
            }, 
            guestsValue: function(){
                this.$parent.$parent.$emit('update-data',{
                    adults: this.adultsValue
                })
                 this.$parent.$parent.$emit('update-data',{
                    children: this.childrenValue
                })
            }
        },
        methods:{
            changeValueAdults( operation){
                if( (operation === 'subtract' && this.adultsValue === this.getRange().minRangeAdults) || 
                    (operation === 'add' && this.adultsValue == this.getRange().maxRangeAdults)
                  )
                    return;
                if(operation === 'subtract' ){
                    this.adultsValue -= 1
                }else{
                    this.adultsValue += 1
                }
            },
            changeValueChildren(operation){
                if((operation === 'subtract' && this.childrenValue === this.getRange().minRangeChildren) || 
                   (operation === 'add' && this.childrenValue == this.getRange().maxRangeChildren)  
                   )
                    return;
                if(operation === 'subtract' ){
                    this.childrenValue -= 1
                }else{
                    this.childrenValue += 1
                }
            },
            toggleOpenPopup(){
                this.isOpenPopup = !this.isOpenPopup
            },
            getRange(){

                let rangeAdults = this.fields['adults'].range.split('-')
                let maxRangeAdults = parseInt(rangeAdults[1]);

                if( rangeAdults[1] < rangeAdults[0] ){
                    maxRangeAdults = rangeAdults[1]
                }

                let rangeChildren = this.fields['children'].range.split('-')
                let maxRangeChildren = parseInt(rangeChildren[1]);

                if( rangeChildren[1] < rangeChildren[0] ){
                    maxRangeChildren = rangeChildren[1]
                }
                return {
                    minRangeAdults: parseInt(rangeAdults[0]),
                    maxRangeAdults: maxRangeAdults,
                    minRangeChildren: parseInt(rangeChildren[0]),
                    maxRangeChildren: maxRangeChildren,
                }
            },

        },
      
    }

</script>

<style lang="scss">
    .field-container{
        position: relative;
        input[type=text]{
            background-size: 17px;
            padding: 0;
            outline: none;
            &::placeholder{
                color: var(--color-placeholder);
                text-transform: var(--text-transform-placeholder);
                text-align: left;
            }
            
        }
        &__guest-popup{
            position: absolute;
            padding: 0px;
            background-color: white;
            width: 100%;
            z-index: 100;
            min-width: 110px;
            .section-popup{
                label{
                    background-color: var(--background-color);
                    display: block;
                    width: 100%;
                    padding: 5px;
                    font-size: 14px;
                    margin-bottom: 0;
                    color: var(--color-placeholder);
                }
                .input{
                    display: flex;
                    height: 32px;
                        button{
                            &:nth-child(2){
                                border-left: 1px solid rgba($color: #000000, $alpha: 0.3);
                                border-right: 1px solid rgba($color: #000000, $alpha: 0.3);
                                &:hover{
                                    border-color: var(--background-color);
                                }
                            }
                        }
                }
                button{
                    cursor: pointer;
                    transition: all 0.3s ease-in-out;
                    outline: none;
                    padding: 5px 13px;
                    background: transparent;
                    border: none;
                    line-height: 1;
                    &:hover{
                        background-color: var(--background-color);
                        color: var(--color-placeholder);
                    }
                }
                input{
                    padding:  0 15px;
                    border: none;
                    height: 32px;
                }
            }
        }
    }
</style>

